import { ProductOptions } from "./ProductOptions";

export const ProductColors = {
  [ProductOptions.Gateway]: "rgba(200, 50, 0, 1)",
  [ProductOptions.Settings]: "rgba(39, 174, 96, 1)",
};